xplenty.filter('escapeHtml', [
  function () {
    return function (txt) {
      return _.escape(txt);
    };
  },
]);
